import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BlogForm from "./BlogForm";
import { addBlog } from "../../api/BlogService";

const BlogAdd = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const initialValues = {
    title: "",
    slug: "",
    blogDescription: "",
    blogCategory: "",
    productCategory: "",
    author: "",
    readingTime: "",
    seoTitle: "",
    seoDescription: "",
    keywords: "",
    content: "",
    status: "ACTIVE",
    coverImage: null,
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      setErrors({});

      const payload = {
        title: values.title,
        blogDescription: values.description,
        excerpt: values.excerpt,

        // Required fields
        category: values.category,
        productCategory: values.productCategory,

        author: values.author,
        publishedDate: values.publishedDate,
        readingTime: Number(values.readingTime),
        content: values.content,
        status: values.status,
        referenceType: values.referenceType || "Blog",
        metaTitle: values.metaTitle || values.title || "",
        metaDescription: values.metaDescription || "",
        metaKeywords: Array.isArray(values.metaKeywords)
          ? values.metaKeywords
          : (values.metaKeywords || "")
              .split(",")
              .map((item) => item.trim())
              .filter(Boolean),
        metaImage: values.metaImage || "",
      };

      const res = await addBlog(payload);

      if (res.success) {
        return res;
      }

      if (res.error) {
        setErrors(res.error);
      }

      return res;
    } catch (error) {
      console.error("API ERROR", error);

      const responseError =
        error?.response?.data?.error ||
        error?.response?.data?.errors ||
        error?.response?.data ||
        { message: error?.message || "Submit failed" };

      setErrors(responseError);
      return { success: false, error: responseError };
    } finally {
      setLoading(false);
    }
  };

  return (
    <BlogForm
      initialValues={initialValues}
      onSubmit={handleSubmit}
      loading={loading}
      errors={errors}
      onSuccess={() => navigate("/blog")}
      onCancel={() => navigate("/blog")}
    />
  );
};

export default BlogAdd;
